import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LanguageGate from './components/LanguageGate';
import Header from './components/Header';
import Hero from './components/Hero';
import ServiceMenu from './components/ServiceMenu';
import Shop from './components/Shop';
import Blog from './components/Blog';
import DiscountTimer from './components/DiscountTimer';
import FloatingElements from './components/FloatingElements';
import ScrollToTop from './components/ScrollToTop';
import DiscountPopup from './components/DiscountPopup';

function App() {
  const [lang, setLang] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check localStorage for language preference
    const savedLang = localStorage.getItem('eyelash_lang');
    if (savedLang) {
      setLang(savedLang);
    }
  }, []);

  const handleLanguageSelect = (selectedLang) => {
    setLang(selectedLang);
    localStorage.setItem('eyelash_lang', selectedLang);
  };

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white text-black font-sans selection:bg-mx-green selection:text-white overflow-x-hidden">
        {!lang && <LanguageGate onSelect={handleLanguageSelect} />}
        
        {lang && (
          <>
            <ScrollToTop />
            <Header />
            <main className="relative">
              {/* Flag Animation Removed as requested */}
              <Routes>
                <Route path="/" element={
                  <>
                    <Hero />
                    <ServiceMenu />
                    <Shop lang={lang} />
                    <Blog />
                  </>
                } />
                <Route path="/services" element={<ServiceMenu />} />
                <Route path="/shop" element={<Shop lang={lang} />} />
                <Route path="/blog" element={<Blog />} />
              </Routes>
            </main>

            {/* Footer */}
            <footer className="bg-black text-white py-12 px-4 border-t border-mx-green relative z-20">
              <div className="max-w-7xl mx-auto text-center">
                <h2 className="text-2xl font-serif font-black mb-4">EYELASHES<span className="text-mx-green">MEXICO</span></h2>
                <div className="flex justify-center gap-4 mb-8 text-sm text-gray-400">
                  <a href="#" className="hover:text-white">Instagram</a>
                  <a href="#" className="hover:text-white">TikTok</a>
                  <a href="#" className="hover:text-white">Facebook</a>
                </div>
                <p className="text-xs text-gray-600 uppercase tracking-widest">
                  &copy; 2025 EyelashesMexico.com | Made in Mexico 🇲🇽
                </p>
              </div>
            </footer>

            <DiscountTimer />
            <FloatingElements />
            <DiscountPopup lang={lang} />
          </>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;